export default "__VITE_ASSET__DuKFqTwW__"